<template>
  <div
    v-if="visible"
    class="skeleton"
  >
    <div
      v-for="_ in 10"
      class="skeleton-item"
    >
      <div class="header" />
      <div class="content">
        <div class="column-1">
          <div
            v-for="_ in 2"
            class="column-1-item"
          >
            <div class="column-1-item-img gradient" />
            <div class="column-1-item-info">
              <div class="div-1 gradient" />
              <div class="div-2 gradient" />
              <div class="div-3 gradient" />
            </div>
          </div>
        </div>
        <div class="column-2">
          <div class="gradient" />
        </div>
        <div
          v-for="_ in 3"
          class="column-3"
        >
          <div class="gradient" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const visible = defineModel('visible', { type: Boolean, default: false })
</script>

<style lang='less' scoped>
.skeleton {
  width: 1200px;
  margin: 0 auto;

  .column-1 {
    width: 584px;
  }

  .column-2 {
    width: 124px;
  }

  .column-3 {
    width: 164px;
  }

  .header {
    height: 40px;
    background-color: #f8f8f8;
  }

  .skeleton-item {
    margin-top: 16px;
    border: 1px solid #ebf1f5;
    border-radius: 4px;
  }

  .content {
    display: flex;
    height: 246px;

    .column-1 {
      padding-left: 24px;
      border-right: 0.5px solid #e4e6eb;
      .column-1-item {
        display: flex;
        gap: 12px;
        height: 128px;
        padding: 16px 0 ;
        border-bottom: 0.5px solid #e4e6eb;

        &:last-child {
          border-bottom: none;
        }

        .column-1-item-img {
          width: 96px;
          height: 96px;
          background-color: #f5f5f5;
          border-radius: 6px;
        }

        .column-1-item-info {
          flex: 1;
          .div-1 {
            width: 81px;
            height: 20px;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
          .div-2 {
            width: 404px;
            height: 24px;
            background-color: #f5f5f5;
            margin-top: 4px;
            border-radius: 4px;
          }
          .div-3 {
            width: 200px;
            height: 24px;
            background-color: #f5f5f5;
            margin-top: 20px;
            border-radius: 4px;
          }
        }
      }
    }

    .column-2 {
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 0.5px solid #e4e6eb;
      div {
        width: 76px;
        height: 24px;
        border-radius: 4px;
        background-color: #f5f5f5;
      }
    }

    .column-3 {
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 0.5px solid #e4e6eb;

      &:last-child {
        border-right: none;
      }

      div {
        width: 116px;
        height: 24px;
        border-radius: 4px;
        background-color: #f5f5f5;
      }
    }
  }

  .gradient {
    background-image: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
    background-size: 200% 100%;
    background-position: 0 0;
    animation: gradient 2s linear infinite;
  }

  @keyframes gradient {
    0% {
      background-position: 0 center;
    }
    100% {
      background-position: 200% center;
    }
  }
}
</style>
